// リアルタイムプレビュー内かどうかを判定
export var isInRealTimePreviewMode = function () {
    var params = new URLSearchParams(window.location.search);
    return (params.get('mode') === 'preview' &&
        params.get('_src') !== 'プレビュー' &&
        params.get('_src') !== 'テンプレートプレビュー');
};
